import { NgModel } from '@angular/forms';
import { Component, ContentChild, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { InputFieldDirective } from '@/core/components/directives/inputs/input-field.directive';
import { InputFieldFloatLabelDirective } from '@/core/components/directives/inputs/input-field-float-label.directive';

@Component({
  selector: 'app-input-field-validation',
  templateUrl: './input-field-validation.component.html',
  styleUrls: ['./input-field-validation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class InputFieldValidationComponent {

  @ContentChild(InputFieldDirective) inputfield: InputFieldDirective;
  @ContentChild(InputFieldFloatLabelDirective) inputfieldFloatLabel: InputFieldDirective;

  @Input("id") id: string;
  @Input("label") label: string;
  @Input("required") required: boolean = false;
  @Input("model") model: NgModel;
  @Input("msg") msg: string;
  @Input("paramsMsg") paramsMsg: any;
  @Input("isShowLoading") isShowLoading: boolean = false;
  @Input("isShowRequiredAsterisk") isShowRequiredAsterisk: boolean = true;
  @Input("isFloatLabel") isFloatLabel: boolean = false;
  @Input("isCounter") isCounter: boolean = false;

  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
  }

  isInvalid() {
    return this.required && this.model && this.model.invalid && (this.model.dirty || this.model.touched);
  }

  counterChars() {
    if (this.isCounter) {
      let inputElement;
      if(this.isFloatLabel && this.inputfieldFloatLabel) {
        inputElement = this.inputfieldFloatLabel?.el?.nativeElement;
      } else {
        inputElement = this.inputfield?.el?.nativeElement;
      }
      const maxLength = inputElement?.getAttribute('maxlength') || 0;
      const currentLength = inputElement?.value?.length || 0;
      return `${currentLength}/${maxLength}`;
    }
    return '';
  }

}
